module.exports = __webpack_public_path__ + "cd9d438b751d4d583778889a0baefbed.svg";